module.exports = extend;

function extend(target){
  for (var i = 1; i < arguments.length; i++) {
    for (var prop in arguments[i]){
      target[prop] = arguments[i][prop];
    }
  }
  return target;
};



//////////////////
// WEBPACK FOOTER
// ./~/keen-core/lib/utils/extend.js
// module id = 1960
// module chunks = 0